export const TableHelpers = {
    data() {
      return {
        tableColumns: [
          
          {
            title: this.$t("Área"),
            type: "custom-html",
            key: "accreditation_area",
            modifier: (value) => {
              return value.name;
            },
          },
          {
            title: "Actividad",
            type: "custom-html",
            key: "accreditation_activity",
            modifier: (value) => {
              return value.name;
            },
          },
          {
            title: "Motivo Queja",
            type: "custom-html",
            key: "reason_complaint",
            modifier: (value) => {
              return value.name;
            },
          },
          {
            title: "Estado",
            type: "custom-html",
            key: "status_complaint",
            modifier: (value) => {
              let ClassName = 'success';
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${value.name}</span>`;
            },
          },
          {
            title: "Fecha de Creación",
            type: "custom-html",
            key: 'created_at',
                    modifier: (value) => {
                        if (value) {
                            return moment(value).format("YYYY-MM-DD HH:mm");
                        }
                    },
          }
          
        ],
        actionObj: {
          title: this.$t("action"),
          type: "action",
        },
      };
    },
  };
  